import { Tabs } from "@modules/financial-information/components/tabs";
import { trans } from "@mongez/localization";
import { FormsTab, InvitationTab, MinutesOfMeetingsAvailableTab } from "./tabs";
import { AnnouncementsTab } from "./tabs/AnnouncementsTab";

export function GeneralAssemblyTabs() {
  return (
    <div className="py-8 lg:py-12">
      <Tabs
        tabs={[
          {
            label: trans("generalAssemblyAnnouncements"),
            value: "generalAssemblyAnnouncements",
            component: () => <AnnouncementsTab />,
          },
          {
            label: trans("invitations"),
            value: "invitations",
            component: () => <InvitationTab />,
          },
          {
            label: trans("forms"),
            value: "forms",
            component: () => <FormsTab />,
          },
          {
            label: trans("minutesOfMeetingsAvailable"),
            value: "minutesOfMeetingsAvailable",
            component: () => <MinutesOfMeetingsAvailableTab />,
          },
        ]}
      />
    </div>
  );
}
